export enum ChatEventsEnum {
	GroupChatCreated = 'group-chat.created',
	PrivateChatCreated = 'private-chat.created',
	PrivateChatRequestApproved = 'private-chat-request.approved',
	MessageCreated = 'message.created',
	MessageRead = 'message.read',
	SystemMessageCreated = 'system-message.created',
	EveryoneMentioned = 'everyone.mentioned',
	UserMentioned = 'user.mentioned',
	ReactionAdded = 'reaction.added',
	ReactionDeleted = 'reaction.deleted',
}
